<template>
<CModal @mtdclosemodal="mtdclosemodal" :show.sync="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <div>
        <div class="list-group mb-3 scroll-container  ">
            <div v-if="stock.length > 0" class="row mx-0 ">
                <div v-for="(item,index) in stock " :key="index"  class="col-xl-3 col-lg-3 px-1 py-1 ">
                    <div   class=" card p-2" >
                        <div class="d-flex w-100 justify-content-between align-items-center mb-3">
                            <h6 class="mb-2 fw-bold text-center" style="font-size: 12px" >
                                {{ item.product_detail.subsubcategorie.name }}
                            </h6>
                        </div>
                        <div  class="">
                            <div class="icon-book d-flex justify-content-center align-items-center mb-3">
                                <img src="../../../../assets/caja.png" alt="" class="img-fluid-bed-sop rounded-start">
                            </div>
                            <div >
                            
                            <h5 class="mb-2" style="font-size: 12px">
                                <strong>LOTE:</strong>
                                {{ item.dispatch_detail.lote }}
                            </h5>        
                            <h5 class="mb-2" style="font-size: 12px">
                                <strong>STOCK :</strong>
                            </h5>
                            <h5 style="font-size: 12px" class=" ps-2">
                                <li v-if="item.productunit.unit_id !=1"> ( {{ item.new_quantity_unit  }} ) {{ item.productunit.unit.name }}</li>
                                <li> ( {{ item.new_quantity }} ) UNIDADES</li>
                            </h5>
                            <div class="mt-1">
                                <button @click="mtdaddunit(item)" v-if="item.new_quantity_unit || item.new_quantity_unit !=0 " type="button" class="btn  btn-sm w-100 btn-info">TRANSFORMA A UNIDADES</button>
                            </div>
                            </div>
                        </div>
                    </div>
                
                </div>
            </div>  
        </div>
    </div>
    <SweetAlert :swal="swal" @mtdaddquantityunit="mtdaddquantityunit" ref="SweetAlert" />
</CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {
    mapActions
} from "vuex";
export default {
    name: "c-logistica-upload",
    components: {
        CModal,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            almacen_id:4,
            subsubcategorieName:'',
            stock:[],
        };
    },
    props: {
        title: String,
        boo_modal: Boolean,
        name:String
    },
    watch: {
        name: {
            handler(newVal) {
                this.mtdGetDatastock()
            },
            immediate: true
        }
    },
    computed: {

    },

    methods: {
        ...mapActions(["get", "post"]),
        mtdclosemodal() {
            this.$emit('mtdcloseModal');
        },
        mtdGetDatastock: function () {
        if (this.name.length >= 4) {
          let data = {
              almacen_id: this.almacen_id,
              subsubcategorieName:this.name
          }
           this.post({
            url: this.$store.getters.get__url + "/Pharmacy/medic/stock",
            token: this.$store.getters.get__token,
            params:data
          })
            .then((response) => {
              if(response.statusCode == 200){
                this.stock = response.data;
               
              }
            })
            .catch((errors) => {
              this.$refs.SweetAlert.showError(errors);
            });

        }
      },

      mtdaddunit:function(item){
          this.$refs.SweetAlert.showStock(item);
      },
      mtdaddquantityunit:function(item){
        this.post({
            url: this.$store.getters.get__url + "/Pharmacy/medic/editStock",
            token: this.$store.getters.get__token,
            params:item
          })
            .then((response) => {
              if(response.statusCode == 200){
                this.$emit('exit_add')
              }
            })
            .catch((errors) => {
              this.$refs.SweetAlert.showError(errors);
            });
      }

    },
};
</script>
